/** Shared categorical identities for dashboard and content charts. */
export const CHART_PALETTE = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "hsl(var(--muted-foreground))",
] as const;

export function chartSeriesColor(index: number): string {
  return CHART_PALETTE[Math.min(Math.max(index, 0), CHART_PALETTE.length - 1)]!;
}

// Legend samples and plotted lines use the same non-color identifier.
export function chartSeriesDash(index: number): string {
  const patterns = ["none", "8 4", "2 3", "8 3 2 3", "12 3 2 3 2 3", "4 3"];
  return patterns[index % patterns.length]!;
}
